import React from "react";
//import { CopyToClipboard } from 'react-copy-to-clipboard';
import "./style.css";

class EmbedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //ModalLoader: false,
      //copied: false
    };
    //this.textarea_ref = React.createRef();
  }
  
  onConfirmDelete = () => {
    console.log("ConfirmModal onConfirmDelete");
    this.props.OnConfirmDelete();
  }

  render() {
    return (
      
      <div id="Category-Personalize-Modal">
        <div className="embed-modal">
              <React.Fragment>
                <div className="header">
                  <h2>{this.props.modalText}</h2>
                  <div align="right" style={{ fontSize: "smaller" }}>
                    <button onClick={() => this.props.hideConfirmModal()} style={{ marginBottom: '2px' }}>Don't do it!</button>
                    <button onClick={() => this.props.OnConfirmDelete()} style={{ marginLeft: '10px', marginBottom: '2px', marginRight: '5px' }}>Confirm Deletion</button>
                  </div>
                </div>
              </React.Fragment>
        </div>
      </div>
      
    );
  }
}

export default EmbedModal;
